import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "../../elements/Theme";
import ResizableImage from "../../elements/ResizableImage";
import OrangeHighlightButton from "../../elements/OrangeHighlightButton";

const ReserveNPricingLinkFrame: React.FC = () => {
  let history = useHistory();

  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLaptop = useMediaQuery(theme.breakpoints.down("lg"));

  const ageGroups = [
    {
      url: "/homePage/kinder1.webp",
      titleKey: "titleCard1",
      subtitleKey: "subtitleCard1",
    },
    {
      url: "/homePage/kinder2.webp",
      titleKey: "titleCard2",
      subtitleKey: "subtitleCard2",
    },
    {
      url: "/homePage/kinder3.webp",
      titleKey: "titleCard3",
      subtitleKey: "subtitleCard3",
    },
  ];

  const handleClick = (route: string) => {
    const path =
      currentLanguage === "en" ? `/${route}` : `/${currentLanguage}/${route}`;
    history.push(path);
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        display: "flex",
        px: isMobile ? "20px" : "73px",
        pb: "8%",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Typography
        variant="h2"
        fontWeight="800"
        mx="auto"
        textAlign="center"
        gutterBottom
        color="text.secondary"
        mt={4}
      >
        {t("ReserveNPricingLinkFrame.title")}
      </Typography>
      <Box display="flex" justifyContent="center" mt="4%" mb="10%">
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          {ageGroups.map((ageGroup, index) => (
            <Grid
              item
              sm={6}
              md={3}
              key={index}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Card
                sx={{
                  borderRadius: "18px",
                  border: `2px solid ${theme.palette.primary.light}`,
                  maxWidth: "340px",
                }}
              >
                <CardMedia>
                  <ResizableImage src={ageGroup.url} height="auto" />
                </CardMedia>
                <CardContent>
                  <Typography
                    variant={"h4"}
                    sx={{ fontWeight: 800 }}
                    textAlign="center"
                    color="primary.light"
                  >
                    {t(`ReserveNPricingLinkFrame.${ageGroup.titleKey}`)}
                  </Typography>
                  <Typography
                    variant={"h5"}
                    sx={{ fontWeight: 400 }}
                    textAlign="center"
                  >
                    {t(`ReserveNPricingLinkFrame.${ageGroup.subtitleKey}`)}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          variant={"h4"}
          textAlign={isLaptop ? "center" : "start"}
          my="5vh"
          sx={{ fontWeight: 400, width: isLaptop ? "100%" : "75%" }}
        >
          {t("ReserveNPricingLinkFrame.text1")}
          <br />
          <br />
          {t("ReserveNPricingLinkFrame.text2")}
        </Typography>
        {!isLaptop && (
          <img
            src="/birds/light-blue.webp"
            alt="Описание"
            style={{
              position: "absolute",
              transform: "rotate(-40deg)",
              width: "40%",
              height: "auto",
              right: "-314px",
            }}
          />
        )}
      </Box>
      <Box
        mt="5vh"
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          height: "56px",
        }}
      >
        <Box>
          <OrangeHighlightButton onClick={() => handleClick("our-program")}>
            <Typography variant="h5">
              {t("ReserveNPricingLinkFrame.button1")}
            </Typography>
          </OrangeHighlightButton>
        </Box>
        <Box>
          <OrangeHighlightButton onClick={() => handleClick("pricing")}>
            <Typography variant="h5">
              {t("ReserveNPricingLinkFrame.button2")}
            </Typography>
          </OrangeHighlightButton>
        </Box>
      </Box>
    </Box>
  );
};

export default ReserveNPricingLinkFrame;
